<template>
    <div class="role_key">
        <van-icon name="cross" class="close" @click="close"/>
        <p>交易口令</p>
        <van-field id="valueInput" :class="{'active':active}" maxlength="6" placeholder="请输入交易口令" v-Alphabet autocomplete="off" v-model="key"/>
        <van-button class="confirm_btn" color="var(--theme)" round :disabled="disabled" :loading="loading" @click="confirm">确定</van-button>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                disabled: true,
                key: '',
                active: false,
                loading: false
            }
        },
        computed: {},
        created() {},
        mounted() {
            
        },
        methods: {
            close() {
                this.$emit('closeModal')
            },
            confirm() {
                var that = this
                this.loading = true
                this.$Ajax('goods-role/index-by-key',{key:this.key},'get').then(rs => {
                    if(rs.code == 200) {
                        this.$router.push({
                            name: 'acc.goods',
                            query: {
                                goods_id: rs.data.id
                            }
                        })
                    }else {
                        this.$toast(rs.msg)
                    }
                    setTimeout(() => {
                        that.loading = false
                    },2000)
                }).finally(() => {
                    setTimeout(() => {
                        that.loading = false
                    },2000)
                })
            }
        },
        watch: {
            key(k) {
                if(k.length > 0) {
                    this.active = true
                    if(k.length == 6) {
                        this.disabled = false
                    }else {
                        this.disabled = true
                    }
                }else {
                    this.active = false
                    this.disabled = true
                }
            }
        },
    }
</script>

<style lang="less" scoped>
.role_key {
    position: relative;
    padding: 2.5rem 1.3rem;
}
.close {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 1.8rem;
    font-weight: 700;
    cursor: pointer;
}
p {
    font-size: 1.6rem;
    color: #000;
    font-weight: 700;
    text-align: center;
    margin-bottom: 2rem;
}
.van-field {
    border: 1px solid #A4A4A4;
    height: 4rem;
    padding: 0;
    border-radius: 1rem;
    &.active {
        border-color: var(--theme);
        background-color: #FFE4D8;
    }
    /deep/.van-field__body {
        height: 100%;
        .van-field__control {
            height: 100%;
            line-height: 4rem;
            padding: 0 1.3rem;
            font-size: 1.4rem;
            color: #000;
        }
    }
}
.confirm_btn {
    width: 100%;
    margin-top: 2rem;
    height: 3.6rem;
    line-height: 3.6rem;
    font-size: 1.6rem;
    color: #fff;
    &:disabled,
    &.van-button--loading {
        background-color: #a4a4a4 !important;
        border-color: #A4A4A4 !important;
    }
}
</style>